import { LoanType, LoanTypeId } from '../../interfaces';
import MultiSelectOption from './MultiSelectOption';
import { default as ReactSelect } from 'react-select';
import { FC, useState, useEffect } from 'react';

const options = [
  {
    value: LoanTypeId.MORTGAGE,
    label: LoanType.MORTGAGE,
  },
  {
    value: LoanTypeId.EQUITY_FINANCE,
    label: LoanType.EQUITY_FINANCE,
  },
  {
    value: LoanTypeId.PAYDAY,
    label: LoanType.PAYDAY,
  },
  {
    value: LoanTypeId.RENT,
    label: LoanType.RENT,
  },
];

type Props = {
  defaultValues?: string | null;
  updateSelectedValue: (value: string) => void;
};

type LoanTypeFilterOption = {
  value: LoanTypeId;
  label: LoanType;
};

const LoanTypeFilter: FC<Props> = ({ defaultValues, updateSelectedValue }) => {
  const [selectedOptions, setSelectedOptions] = useState<LoanTypeFilterOption[]>([]);

  const handleChange = (selected: any) => {
    console.log('SELECTED LOAN TYPE');

    setSelectedOptions(selected);

    const values = (selected as LoanTypeFilterOption[]).map((item) => item.value).join(',');

    updateSelectedValue(values);
  };

  useEffect(() => {
    if (defaultValues) {
      const filterOptions: LoanTypeFilterOption[] = [];
      defaultValues.split(',').forEach((item) => {
        const optionExists = options.find((option) => option.value === parseInt(item));
        if (optionExists) {
          filterOptions.push(optionExists);
        }
      });
      setSelectedOptions(filterOptions);
    }
  }, [defaultValues]);

  return (
    <ReactSelect
      options={options}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      components={{
        Option: MultiSelectOption,
      }}
      onChange={handleChange}
      value={selectedOptions}
      isClearable={false}
    />
  );
};

export default LoanTypeFilter;
